/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
import axios from 'axios';

// import ScrollMenu from "react-horizontal-scrolling-menu";

// import { loadProgressBar } from "axios-progress-bar";
// import queryString from "query-string";

import ContentItemVod from '../../components/ContentItemVod';
// import InfiniteScroll from "react-infinite-scroll-component";
import PerfectScrollbar from 'react-perfect-scrollbar';

import TagSameCode from './TagSameCode';
import TagGenreCode from './TagGenreCode';
import TagTagCode from './TagTagCode';
import TagViewCode from './TagViewCode';
// import TagMemberShipCode from "./TagMemberShipCode";
// import TagSearchBanner from "./TagSearchBanner";

import TagSearchBox from './TagSearchBox';
import ThemeRolling from './ThemeRolling';

import TagSearchMain from './TagSearchMain';
import Footer from '../../components/Footer';
import BarBannerItem from '../../components/banner/BarBannerItem';
import moment from 'moment';

//import ProgressContainer from '../containers/ProgressContainer'

class TagSearchList extends Component {
  state = {
    gotoPage: 1,
    curPage: 0,
    pageSize: 20,
    sameCode: [],
    genreCode: [],
    tagCode: [],
    viewCode: [],
    searchList: [],
    init: false,
    m1Check: false,
    m2Check: false,
    m3Check: false,
    m4Check: false,
    m5Check: false,
    m6Check: false,
    sortValue: 0,
    onOverWith: false,
    allShow: true,
    filterShow: isMobile || isAndroid || isIOS ? false : true,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    window.addEventListener('scroll', this._scrollPage);
    document.addEventListener('touchmove', this._scrollPage);

    const { gotoPage } = this.state;
    const { part, code } = this.props.childProps;
    //console.log('===>')
    //console.log(part, code)
    this._getBanner();
    if (part === null || part === '' || part === undefined) {
      this._getSearchData(gotoPage);
    } else if (part === 'same') {
      //동시방역작.
      if (code === '' || code === null || code === undefined) {
        this._getSearchData(gotoPage);
      } else {
        this._sameCodeAdd(code);
      }
    } else if (part === 'tag') {
      if (code === '' || code === null || code === undefined) {
        this._getSearchData(gotoPage);
      } else {
        this._tagCodeAdd(code);
      }
    } else if (part === 'genre') {
      if (code === '' || code === null || code === undefined) {
        this._getSearchData(gotoPage);
      } else {
        this._genreCodeAdd(code);
      }
    }
  };
  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('scroll', this._scrollPage);
    document.removeEventListener('touchmove', this._scrollPage);
  }

  _scrollPage = () => {
    const { gotoPage, curPage } = this.state;

    // const { part } = this.props.childProps;
    const windowHeight =
      'innerHeight' in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;

    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    // console.log(windowBottom, docHeight, docHeight - 800);
    // var scrollHeight = Math.max(
    //   document.documentElement.scrollHeight,
    //   document.body.scrollHeight
    // );
    // var scrollTop = Math.max(
    //   document.documentElement.scrollTop,
    //   document.body.scrollTop
    // );
    // var clientHeight = document.documentElement.clientHeight;

    ////console.log(windowHeight,  window.pageYOffset)
    ////console.log(scrollTop + clientHeight)
    ////console.log(scrollHeight)
    if (windowBottom >= docHeight - 800) {
      //if((scrollTop + clientHeight + 300) >= scrollHeight){
      ////console.log('call')
      ////console.log(curPage, gotoPage)
      if (curPage !== gotoPage) {
        this.setState({
          curPage: gotoPage,
        });
        setTimeout(() => {
          this._getSearchData(gotoPage);
        }, 500);
      } else {
        //console.log('다름..')
      }
    } else {
      //console.log('not bottom')
    }
  };
  /*
    UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
        return (this.props.childProps.strFind !== nextProps.childProps.strFind)
    }
    componentWillReceiveProps = (nextProps) => {
        if(this.props.childProps.strFind !== nextProps.childProps.strFind) {
            this._getSearchData(1)
        }
    }
    */
  _getBanner = async () => {
    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const barBannerList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          barBannerList,
        });
      }
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/topBannerBar')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _getSearchData = async (gotoPage) => {
    // const { curPage } = this.state;
    const result = await this._getSearchDataApi(gotoPage);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const searchList = result.data[0].listData;

    ////console.log(intReturn)

    //console.log(gotoPage, pageCount, con)
    //console.log(searchList)
    if (this._isMounted) {
      if (intReturn === 0) {
        if (con > 0) {
          //return searchList
          //console.log('con > 0')
          this.setState({
            gotoPage: gotoPage + 1,
            //curPage: curPage + 1,
            con: con,
            searchList:
              gotoPage === 1
                ? searchList
                : this.state.searchList.concat(searchList),
            hasMore: pageCount < gotoPage ? false : true,
          });
        } else {
          //console.log('con < 0')
          this.setState({
            gotoPage: 1,
            //curPage: 0,
            con: con,
            searchList: searchList,
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      } else {
        //console.log('intReturn <> 0')
        this.setState({
          gotoPage: 1,
          curPage: 0,
          con: con,
          searchList: [],
          hasMore: pageCount < gotoPage ? false : true,
        });
      }
    }
  };
  _getSearchDataApi = (gotoPage) => {
    const { apiUrl, loginId } = this.props;
    const { m1Check, m2Check, m3Check, m4Check, m5Check, m6Check, sortValue } =
      this.state;
    ////console.log(sameCode)

    const stringSameCode = this._getStringSameCode();
    const stringGenreCode = this._getStringGenreCode();
    const stringTagCode = this._getStringTagCode();
    const stringViewCode = this._getStringViewCode();
    ////console.log(stringSameCode)

    //POST 방식으로 바꿀수도 있음...
    return axios
      .post(apiUrl + '/tagSearch', {
        params: {
          userid: loginId,
          sameCode: stringSameCode,
          genreCode: stringGenreCode,
          tagCode: stringTagCode,
          viewCode: stringViewCode,
          m1: m1Check,
          m2: m2Check,
          m3: m3Check,
          m4: m4Check,
          m5: m5Check,
          m6: m6Check,
          sort: sortValue,
          gotoPage: gotoPage,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
    /*
        //console.log(apiUrl + '/tagSearch?sameCode=' + stringSameCode + '&genreCode=' + stringGenreCode + '&tagCode=' + stringTagCode + '&viewCode=' + stringViewCode + '&m1=' + m1Check + '&m2=' + m2Check + '&m3=' + m3Check + '&m4=' + m4Check + '&m5=' + m5Check + '&m6=' + m6Check + '&sort=' + sortValue + '&gotoPage=' + gotoPage)
        return axios(apiUrl + '/tagSearch?sameCode=' + stringSameCode + '&genreCode=' + stringGenreCode + '&tagCode=' + stringTagCode + '&viewCode=' + stringViewCode + '&m1=' + m1Check + '&m2=' + m2Check  + '&m3=' + m3Check + '&m4=' + m4Check + '&m5=' + m5Check + '&m6=' + m6Check + '&sort=' + sortValue + '&gotoPage=' + gotoPage)
        .then(response => response)
        .catch(error => {
            //console.log('검색오류...')
        })
        */
  };
  _getStringSameCode = () => {
    const { sameCode } = this.state;

    let stringSameCode = '';
    sameCode.map((item, index) => {
      stringSameCode = stringSameCode + item + '|';
    });

    return stringSameCode;
  };
  _getStringGenreCode = () => {
    const { genreCode } = this.state;

    let stringGenreCode = '';
    genreCode.map((item, index) => {
      stringGenreCode = stringGenreCode + item + '|';
    });

    return stringGenreCode;
  };
  _getStringTagCode = () => {
    const { tagCode } = this.state;

    let stringTagCode = '';
    tagCode.map((item, index) => {
      stringTagCode = stringTagCode + item + '|';
    });

    return stringTagCode;
  };
  _getStringViewCode = () => {
    const { viewCode } = this.state;

    let stringViewCode = '';
    viewCode.map((item, index) => {
      stringViewCode = stringViewCode + item + '|';
    });

    return stringViewCode;
  };

  _renderItem = () => {
    const { searchList } = this.state;

    const list = searchList.map((item, index) => {
      return (
        <div style={{ display: 'inline-block' }}>
          <ContentItemVod
            key={index}
            num={index + 1}
            refer={'tagSearch'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            onEndItemSlide={this._onEndItemSlide}
            subTitle={item.subTitle}
          />
        </div>
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    //alert(num)
    //console.log(num)
    //console.log(num%6)
    if (parseInt(num % 6) === 0) {
      //console.log('over...')
      this.setState({
        onOverWith: over,
      });
    }
  };
  _sameCodeAdd = (code) => {
    const { sameCode } = this.state;

    sameCode.push(code);

    this.setState({
      sameCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _sameCodeDel = (code) => {
    const { sameCode } = this.state;
    sameCode.splice(sameCode.indexOf(code), 1);

    this.setState({
      sameCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _genreCodeAdd = (code) => {
    const { genreCode } = this.state;

    genreCode.push(code);

    this.setState({
      genreCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _genreCodeDel = (code) => {
    const { genreCode } = this.state;
    genreCode.splice(genreCode.indexOf(code), 1);

    this.setState({
      genreCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _tagCodeAdd = (code) => {
    const { tagCode } = this.state;

    tagCode.push(code);

    this.setState({
      tagCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _tagCodeDel = (code) => {
    const { tagCode } = this.state;
    tagCode.splice(tagCode.indexOf(code), 1);

    this.setState({
      tagCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _viewCodeAdd = (code) => {
    const { viewCode } = this.state;
    //console.log(code)
    viewCode.push(code);

    this.setState({
      viewCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _viewCodeDel = (code) => {
    const { viewCode } = this.state;
    viewCode.splice(viewCode.indexOf(code), 1);

    this.setState({
      viewCode,
      init: false,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };

  _onChkInit = () => {
    this.setState({
      gotoPage: 1,
      sameCode: [],
      genreCode: [],
      tagCode: [],
      viewCode: [],
      init: true,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _m1Change = () => {
    const { m1Check } = this.state;

    this.setState({
      m1Check: !m1Check,
      init: false,
    });
    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _m2Change = () => {
    const { m2Check } = this.state;

    this.setState({
      m2Check: !m2Check,
      init: false,
    });
    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _m3Change = () => {
    const { m3Check } = this.state;

    this.setState({
      m3Check: !m3Check,
      init: false,
    });
    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _m4Change = () => {
    const { m4Check } = this.state;
    //alert(0)
    this.setState({
      m4Check: !m4Check,
      init: false,
    });
    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _m5Change = () => {
    const { m5Check } = this.state;

    this.setState({
      m5Check: !m5Check,
      init: false,
    });
    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _m6Change = () => {
    const { m6Check } = this.state;

    this.setState({
      m6Check: !m6Check,
      init: false,
    });
    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _onSortChange = (e) => {
    this.setState({
      sortValue: e.target.value,
    });

    setTimeout(() => {
      this._getSearchData(1);
    }, 300);
  };
  _showTimeline = () => {
    const { setTimeline } = this.props;
    setTimeline(true);
  };
  _renderBox = () => {
    const { con, searchList } = this.state;
    //console.log(con)

    let temp = [];

    for (let i = 0; i < con; i = i + 6) {
      temp.push(
        <TagSearchBox
          key={i}
          searchList={searchList.filter((item, index) => {
            return index >= i && index < i + 6;
          })}
        />
      );
    }

    const list = temp.map((item, index) => {
      return item;
    });
    return list;
  };
  _onBanner = () => {
    const { setEventId } = this.props;
    setEventId(278);
  };
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _allShow = () => {
    const { allShow } = this.state;
    this.setState({
      allShow: !allShow,
    });
  };
  _openFilter = () => {
    this.setState({
      filterShow: true,
    });
  };
  _closeFilter = () => {
    this.setState({
      filterShow: false,
    });
  };
  render() {
    const {
      searchList,
      barBannerList,

      con,

      init,
      m1Check,
      m2Check,

      sortValue,
      sameCode,
      genreCode,
      tagCode,
      viewCode,

      allShow,
      gotoPage,
      filterShow,
    } = this.state;
    const { serviceEndDate } = this.props;
    //console.log(sameCode.length, genreCode.length)
    // const { part, code } = this.props.childProps;
    //console.log(m1Check, m2Check)
    return (
      <Fragment>
        <div className="content" style={{ position: 'relative' }}>
          {filterShow && (
            <div className="vod_list_left">
              <div className="left_menu_layer">
                <h1>
                  {/* <ThemeRolling /> */}
                  {/*<a style={{cursor: 'pointer'}} onClick={this._showTimeline}>LIVE 편성표</a>*/}
                </h1>

                {/*
                                 <h1>
                                     <span>전체작품</span>
                                     <strong>{con}</strong>
                                 </h1>
                                 */}
                <div className="left_menu_group">
                  <PerfectScrollbar>
                    <div className="left_menu_list">
                      {/*<h2><a style={{cursor: 'pointer'}} onClick={this._showTimeline}>편성표</a></h2>*/}

                      {/* <div className="close" onClick={this._closeFilter}>
                        <span>닫기</span>
                      </div> */}

                      <h3 className="tit">
                        카테고리
                        <a
                          style={{ cursor: 'pointer' }}
                          onClick={this._onChkInit}
                        >
                          초기화 <img src="img/vod/refresh.png" />
                        </a>
                      </h3>
                      <TagSameCode
                        sameCodeAdd={this._sameCodeAdd}
                        sameCodeDel={this._sameCodeDel}
                        init={init}
                        chkCode={sameCode}
                      />
                      <TagGenreCode
                        genreCodeAdd={this._genreCodeAdd}
                        genreCodeDel={this._genreCodeDel}
                        init={init}
                        chkCode={genreCode}
                      />
                      <TagTagCode
                        tagCodeAdd={this._tagCodeAdd}
                        tagCodeDel={this._tagCodeDel}
                        init={init}
                        chkCode={tagCode}
                      />
                      <TagViewCode
                        viewCodeAdd={this._viewCodeAdd}
                        viewCodeDel={this._viewCodeDel}
                        init={init}
                      />
                      {/*
                                         <TagMemberShipCode 
                                             init={init}
                                         />
                                         */}

                      {/*멤버십/포인트*/}
                      {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                      serviceEndDate ? null : (
                        <div>
                          <dl>
                            <dd>
                              <div className="chek_group">
                                <input
                                  name="선택"
                                  id="checkbox_m_1"
                                  type="checkbox"
                                  value=""
                                  className="checkbox_img"
                                  checked={init ? false : m1Check}
                                  onChange={this._m1Change}
                                />
                                <label htmlFor="checkbox_m_1">
                                  멤버십 이용가능 작품
                                </label>
                              </div>
                            </dd>
                            <dd>
                              <div className="chek_group">
                                <input
                                  name="선택"
                                  id="checkbox_m_2"
                                  type="checkbox"
                                  value=""
                                  className="checkbox_img"
                                  checked={init ? false : m2Check}
                                  onChange={this._m2Change}
                                />
                                <label htmlFor="checkbox_m_2">
                                  포인트 결제 작품
                                </label>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      )}

                      {/*유료/무료*/}
                      {/*
                                         <div>
                                             <dl>
                                                 
                                                 <dd>
                                                     <div className="chek_group">
                                                         <input name="선택" id="checkbox_m_3" type="checkbox" value="" className="checkbox_img" checked={init ? false : m3Check} onChange={this._m3Change}/><label htmlFor="checkbox_m_3">유료</label>
                                                     </div>
                                                 </dd>
                                                 <dd>
                                                     <div className="chek_group">
                                                         <input name="선택" id="checkbox_m_4" type="checkbox" value="" className="checkbox_img" checked={init ? false : m4Check} onChange={this._m4Change}/><label htmlFor="checkbox_m_4">무료</label>
                                                     </div>
                                                 </dd>
                                                 
                                             </dl>
                                         </div>
                                         */}
                      {/*완결/미완결*/}
                      {/*
                                         <div>
                                             <dl>
                                                 
                                                 <dd>
                                                     <div className="chek_group">
                                                         <input name="선택" id="checkbox_m_5" type="checkbox" value="" className="checkbox_img" checked={init ? false : m5Check} onChange={this._m5Change}/><label htmlFor="checkbox_m_5">완결</label>
                                                     </div>
                                                 </dd>
                                                 <dd>
                                                     <div className="chek_group">
                                                         <input name="선택" id="checkbox_m_6" type="checkbox" value="" className="checkbox_img" checked={init ? false : m6Check} onChange={this._m6Change}/><label htmlFor="checkbox_m_6">미완결</label>
                                                     </div>
                                                 </dd>
                                                 
                                             </dl>
                                         </div>
                                         */}
                    </div>
                  </PerfectScrollbar>
                </div>
              </div>
            </div>
          )}

          {/*배너*/}
          <div className="vod_list_right">
            {/* sameCode.length === 0 && genreCode.length === 0 && tagCode.length === 0 && viewCode.length === 0 ? <TagSearchBanner /> : null */}

            {/*배너*/}
            {allShow ? (
              <div className="vod_list_group">
                <h1>
                  검색된 작품 ({con})
                  {/* <div className="vod_list_select">
                    <select
                      name=""
                      className="select_input vod_select"
                      value={sortValue}
                      onChange={this._onSortChange}
                      style={{ backgroundColor: '#000' }}
                    >
                      <option
                        value="0"
                        style={{ fontWeight: '600', fontSize: 14 }}
                      >
                        최신순
                      </option>
                      <option
                        value="1"
                        style={{ fontWeight: '600', fontSize: 14 }}
                      >
                        제목순
                      </option>
                      <option
                        value="2"
                        style={{ fontWeight: '600', fontSize: 14 }}
                      >
                        인기순
                      </option>
                    </select>
                  </div> */}
                </h1>

                {/* <div className="filter" onClick={this._openFilter}>
                  <span>필터 검색</span>
                </div> */}
                <div className="vod_vod_list">
                  <div className="main_list_goup2">
                    {searchList ? this._renderBox() : null}
                    <div className="clear"></div>
                  </div>
                </div>

                <div
                  className="more"
                  onClick={() => this._getSearchData(gotoPage + 1)}
                >
                  <span
                    style={{ fontSize: 16, fontWeight: 700, paddingRight: 3 }}
                  >
                    더보기
                  </span>
                  <img src="img/vod/more.png" />
                </div>
              </div>
            ) : sameCode.length === 0 &&
              tagCode.length === 0 &&
              genreCode.length === 0 &&
              viewCode.length === 0 &&
              m1Check === false &&
              m2Check === false ? (
              <TagSearchMain allShow={this._allShow} />
            ) : (
              <div className="vod_list_group">
                <h1>
                  검색된 작품 ({con})
                  {/* <div className="vod_list_select">
                    <select
                      name=""
                      className="select_input vod_select"
                      value={sortValue}
                      onChange={this._onSortChange}
                      style={{ backgroundColor: '#000' }}
                    >
                      <option
                        value="0"
                        style={{ fontWeight: '600', fontSize: 14 }}
                      >
                        최신순
                      </option>
                      <option
                        value="1"
                        style={{ fontWeight: '600', fontSize: 14 }}
                      >
                        제목순
                      </option>
                      <option
                        value="2"
                        style={{ fontWeight: '600', fontSize: 14 }}
                      >
                        인기순
                      </option>
                    </select>
                  </div> */}
                </h1>

                <div className="vod_vod_list">
                  <div className="main_list_goup2">
                    {searchList ? this._renderBox() : null}
                    <div className="clear"></div>
                  </div>
                </div>
                <div
                  style={{
                    color: '#fff',
                    width: '100%',
                    height: 40,
                    textAlign: 'center',
                  }}
                  onClick={() => this._getSearchData(gotoPage + 1)}
                >
                  <span
                    style={{ fontSize: 16, fontWeight: 700, paddingRight: 3 }}
                  >
                    더보기
                  </span>
                  <img src="img/vod/more.png" />
                </div>

                {barBannerList ? (
                  barBannerList[0] ? (
                    <div className="live_top_baner" style={{ zIndex: 1000 }}>
                      <BarBannerItem
                        index={1}
                        bannerFile={barBannerList[0].bannerFile}
                        bannerFile_s={barBannerList[0].bannerFile_s}
                        LinkURL={barBannerList[0].LinkURL}
                        Linktarget={barBannerList[0].Linktarget}
                        LinkURL_M={barBannerList[0].LinkURL_M}
                        Linktarget_M={barBannerList[0].Linktarget_M}
                        idx={barBannerList[0].idx}
                        comment={barBannerList[0].comment}
                        adComIdx={barBannerList[0].adComIdx}
                        pageCode={barBannerList[0].pageCode}
                      />
                    </div>
                  ) : null
                ) : null}
              </div>
            )}

            <Footer />
          </div>
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TagSearchList));
